// extracted by mini-css-extract-plugin
module.exports = {"icon-size":"_2Q_eGgCSajLq4kG4SWNnHf"};